'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _colors = require('../colors');

var colors = _interopRequireWildcard(_colors);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _IconStack = require('../IconStack');

var _IconStack2 = _interopRequireDefault(_IconStack);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// Temporary fix to resize the icon stack to the correct size.
var scaleStyle = { transform: 'scale(0.65)' };

var ascDirection = 'asc';

var descDirection = 'desc';

var TableHeader = function TableHeader(_ref) {
  var children = _ref.children,
      className = _ref.className,
      sortable = _ref.sortable,
      sorted = _ref.sorted,
      toggleSort = _ref.toggleSort,
      rest = _objectWithoutProperties(_ref, ['children', 'className', 'sortable', 'sorted', 'toggleSort']);

  var direction = sorted && (sorted.desc ? 'desc' : 'asc');

  var sortIcons = _react2.default.createElement(
    _IconStack2.default,
    { style: scaleStyle },
    _react2.default.createElement(_Icon2.default, { color: direction === ascDirection ? colors.shale : colors.alloy, name: 'sort-up-f' }),
    _react2.default.createElement(_Icon2.default, { color: direction === descDirection ? colors.shale : colors.alloy, name: 'sort-down-f' })
  );

  return _react2.default.createElement(
    'div',
    _extends({
      className: (0, _classnames2.default)('rt-th', className),
      role: 'columnheader',
      tabIndex: '-1'
    }, rest, {
      onClick: function onClick(e) {
        return toggleSort && toggleSort(e);
      }
    }),
    children,
    sortable ? sortIcons : null
  );
};

TableHeader.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  sortable: _propTypes2.default.bool,
  toggleSort: _propTypes2.default.func,
  sorted: _propTypes2.default.shape({
    desc: _propTypes2.default.any
  })
};

exports.default = TableHeader;